import React from 'react';
import * as Yup from 'yup';

import FormikInput from 'src/components/formik/FormikInput';
import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import Card from 'src/components/Card';

const fieldsConfig = [
  {
    name: 'firstName',
    component: () => (
      <FormikInput
        fullWidth
        label="First name"
        name="firstName"
        autoFocus
      />
    ),
    gridProps: { md: 6, xs: 12 },
    validator: Yup.string().required(),
  },
  {
    name: 'lastName',
    component: () => (
      <FormikInput
        fullWidth
        label="Last name"
        name="lastName"
      />
    ),
    gridProps: { md: 6, xs: 12 },
    validator: Yup.string().required(),
  },
  {
    name: 'email',
    component: () => (
      <FormikInput
        fullWidth
        label="Email address"
        name="email"
        type="email"
      />
    ),
    gridProps: { md: 6, xs: 12 },
    validator: Yup.string().email('Must be a valid email').required()
  },
  {
    name: 'phoneNumber',
    component: () => (
      <FormikInput
        fullWidth
        label="Phone number"
        name="phoneNumber"
        look="phone"
      />
    ),
    gridProps: { md: 6, xs: 12 },
    validator: Yup.string().required()
  },
];

function GeneralSettings() {
  return (
    <Card title="General settings">
      <CRUDConfigForm
        url="/identity/me/"
        fieldsConfig={fieldsConfig}
        primaryButton={{
          label: 'Save',
          fullWidth: false
        }}
        submitMethodOverride="patch"
      />
    </Card>
  );
}

export default GeneralSettings;
